import { handleActions } from 'redux-actions';
import { obtenerParametros, LOGOUT } from '../../actions';

const stateDefault = [];

export default handleActions(
    {
        [obtenerParametros]: (state, action) => {
            return Object.assign({}, state, action.payload);
        },
        [LOGOUT] : (state, action) => { 
            return Object.assign({}, stateDefault);
        },
    },
    stateDefault
  );